<template>
    <div class="dashboard-component" id="dashboard">
        <div id="headerelement">
            <fixed-header :fixed.sync="isFixed" v-if ="showfixedheader">
                <nav class="navbar" :class="{ 'is-light-vli': isFixed, 'is-primary-vli': !isFixed }">
                    <container>
                    <header v-if ="normaldevice">
                        <div class="inner" style="padding-top:20px;">
                            <grid horizontal="left">
                                <grid-item size="2/12" class="logo-opacity">
                                    <a href="/"><img class="v-middle" src="../assets/images/logo_white.svg"></a>
                                </grid-item>

                                <grid-item size="10/12" class="nav-items">
                                    <ul class="top-menu">
                                        <li><a href="#" @click="navigateToHomeWithDiv('howitwork')">HOW IT WORKS</a></li>
                                        <li><a href="#" @click="navigateToHomeWithDiv('features')">FEATURES</a></li>
                                        <li><a href="#" @click="navigateToHomeWithDiv('plans')">PLANS</a></li>
                                        <li><a href="#" v-scroll-to="'#plans'">BLOG</a></li>
                                        <li><a href="#" @click="openNewTab()">SIGNIN</a></li>
                                    </ul>
                                    <!-- <button class="btn-head banner-head-get-btn raise banner-head-vil-btn" type="button"  @click="navigateToHomeWithDiv('plans')">SUBSCRIBE</button> -->
                                </grid-item>


                            </grid>
                        </div>
                    </header>
                    <header v-if ="smalldevice">
                        <div class="inner-sm">
                            <grid horizontal="left">
                                <grid-item size="2/12" class="logo-opacity">
                                    <a href="/"><img class="v-middle" src="../assets/images/logo_white.svg"></a>
                                    <!-- <span class="logo-text">vLite</span> -->
                                </grid-item>

                                <grid-item size="10/12" class="nav-items">
                                    <button type="button" class="btn-hamb" @click="toggleSidebar">
                                        <span class="strike"></span>
                                        <span class="strike"></span>
                                        <span class="strike"></span>
                                    </button>
                                    <!-- <button class="btn-head banner-head-get-btn raise banner-head-vil-btn" type="button"  @click="navigateToHomeWithDiv('plans')">SUBSCRIBE</button> -->
                                </grid-item>


                            </grid>

                            <div class="sidebar" v-show="sidebarVisible">
                                <div class="menus">
                                    <ul>
                                        <li><a href="#" @click="navigateToHomeWithDiv('howitwork')">HOW IT WORKS</a></li>
                                        <li><a href="#" @click="navigateToHomeWithDiv('features')">FEATURES</a></li>
                                        <li><a href="#" @click="navigateToHomeWithDiv('plans')">PLANS</a></li>
                                        <li><a href="#" v-scroll-to="'#plans'">BLOG</a></li>
                                        <li><a href="#" @click="openNewTab()">SIGNIN</a></li>

                                    </ul>
                                </div>
                                <button type="button" class="btn-close-sidebar" @click="toggleSidebar">
                                    <icon scale="2.5" style="color:#bcbcbc;" name="times"></icon>
                                </button>
                            </div>
                        </div>
                    </header>
                </container>
                </nav>
            </fixed-header>
            <div class="banner dashboard-banner">
                <container>
                    <header v-if ="normaldevice">
                        <div class="inner">
                            <grid horizontal="left">
                                <grid-item size="2/12" class="pointer logo-opacity">
                                    <a href="/">
                                        <img class="v-middle" src="../assets/images/logo_white.svg">
                                    </a>
                                </grid-item>

                                <grid-item size="10/12" class="nav-items">
                                    <ul class="top-menu">
                                        <li><a href="#" @click="navigateToHomeWithDiv('howitwork')">HOW IT WORKS</a></li>
                                        <li><a href="#" @click="navigateToHomeWithDiv('features')">FEATURES</a></li>
                                        <li><a href="#" @click="navigateToHomeWithDiv('plans')">PLANS</a></li>
                                        <li><a href="#" v-scroll-to="'#plans'">BLOG</a></li>
                                        <li><a href="#" @click="openNewTab()">SIGNIN</a></li>
                                    </ul>
                                </grid-item>


                            </grid>
                        </div>
                    </header>
                    <header v-if ="smalldevice">
                        <div class="inner-sm">
                            <grid horizontal="left">
                                <grid-item size="2/12" class="logo-opacity">
                                    <a href="/"><img class="v-middle" src="../assets/images/logo_white.svg"></a>
                                    <!-- <span class="logo-text">vLite</span> -->
                                </grid-item>

                                <grid-item size="10/12" class="nav-items">
                                    <button type="button" class="btn-hamb" @click="toggleSidebar">
                                        <span class="strike"></span>
                                        <span class="strike"></span>
                                        <span class="strike"></span>
                                    </button>
                                </grid-item>


                            </grid>

                            <div class="sidebar" v-show="sidebarVisible">
                                <div class="menus">
                                    <ul>
                                        <li><a href="#" @click="navigateToHomeWithDiv('howitwork')">HOW IT WORKS</a></li>
                                        <li><a href="#" @click="navigateToHomeWithDiv('features')">FEATURES</a></li>
                                        <li><a href="#" @click="navigateToHomeWithDiv('plans')">PLANS</a></li>
                                        <li><a href="#" v-scroll-to="'#plans'">BLOG</a></li>
                                        <li><a href="#" @click="openNewTab()">SIGNIN</a></li>

                                    </ul>
                                </div>
                                <button type="button" class="btn-close-sidebar" @click="toggleSidebar">
                                    <icon scale="2.5" style="color:#bcbcbc;" name="times"></icon>
                                </button>
                            </div>
                        </div>
                    </header>
                    <div class="banner-content">
                        <h1 class="white-text">Subscription</h1>
                        <h2 class="white-text">You’ve selected <strong>{{planData.planname}}</strong> Plan</h2>
                        <grid horizontal="left" class="vl-rltv">
                            <grid-item size="8/12" class="zindex101" v-if ="higherplanstatus">
                                <h3 class="white-text">Get <strong>5x</strong> watching minutes/month and <strong>2x</strong> hours of content with <strong>{{priorplan.planname}}</strong> plan at discounted rate of <strong>${{priorplan.yearlydiscountedprice/100}}</strong> annually.</h3>
                                <button v-if ="higherplanstatus" class="btn banner-get-btn-home raise" type="button" @click="switchTopriorPlan()">SELECT {{priorplanname}} PLAN AND PROCEED</button>
                                <a v-if ="lowerplanstatus" @click="switchBackTopriorPlan">
                                <p class="dash-skip-plan"><u>Skip and proceed with {{skipplanname}} plan</u></p></a>
                            </grid-item>
                            <grid-item  size="4/12" class="v-middle right zindex101 vl-bnr-top-ico">
                                <div class="top-right-gfx">
                                </div>
                            </grid-item>
                        </grid>

                    </div>
                </container>
            </div>
        </div>
    <form id="signupform" @submit.prevent="onFormSubmit">
        <div v-bind:class="dashbasicinfo">
            <container id="basicinfobox">
                <p class="center dash-form-head">BASIC INFORMATION</p>
                <div class="clearfix"></div>
                <grid horizontal="middle" class="dash-form-ele">
                    <grid-item size="3/12">
                    </grid-item>
                    <grid-item size="6/12">
                        <div class="form-group" :class="{'has-error': errors.has('appname') }">
                            <label class="dash-form-label" for="appname">Tell Us Your App Name</label><span class="text-danger">*</span>
                            <input v-model="appname" id="appname" name="appname" maxlength="50" v-validate.initial="appname" data-vv-rules="required|max:16" class="dash-form-text-val m-top-10 width-100" type="text" value="" :class="{'has-error': errors.has('appname') }">
                        </div>
                    </grid-item>
                </grid>

                <grid horizontal="middle" class="dash-form-ele">
                    <grid-item size="3/12">
                    </grid-item>
                    <grid-item size="6/12">
                        <div class="form-group" :class="{'has-error': errors.has('appdesc') }">
                            <label class="dash-form-label" for="appdesc">Describe <strong>{{appname}}</strong> in one Sentence</label><span class="text-danger">*</span>
                            <input v-model="appdesc" v-validate.initial="appdesc" data-vv-rules="required" class="dash-form-text-val m-top-10 width-100" type="text" id="appdesc" name="appdesc" value="" maxlength="256" :class="{'has-error': errors.has('appdesc') }">
                        </div>
                    </grid-item>
                </grid>

                <grid horizontal="middle" class="dash-form-ele">
                    <grid-item size="3/12">
                    </grid-item>
                    <grid-item size="6/12">
                        <label class="dash-form-label">Select use case of <strong>{{appname}}</strong></label>
                        <grid class="m-top-10">
                            <grid-item size="3/6" class="">
                                <label class="control control--radio dash-form-chk-label">MOOC
                                    <input type="radio" name="type" value="MOOC" checked="checked" @click="usecaseChange('MOOC')"/>
                                    <div class="control__indicator"></div>
                                </label>
                            </grid-item>
                            <grid-item size="3/6" class="dash-form-chk">
                                <label class="control control--radio dash-form-chk-label">Entertainment
                                    <input type="radio" name="type" value="LITE" @click="usecaseChange('LITE')"/>
                                    <div class="control__indicator"></div>
                                </label>
                            </grid-item>
                        </grid>
                    </grid-item>
                </grid>

                <grid horizontal="middle" class="dash-form-ele" id="fileupload-div">
                    <grid-item size="3/12">
                    </grid-item>
                    <grid-item size="6/12">
                        <input type="hidden" id="logo" name="logo" v-bind:value="filename" />
                        <div class="form-group" :class="{'has-error': errors.has('appdesc') }">
                            <label class="dash-form-label" for="filename">Upload logo of <strong>{{appname}}</strong></label><span class="text-danger">*</span>
                            <grid class="m-top-10">
                                <grid-item size="4/6">
                                    <label id="dash-fileup-label-msg" class="dash-form-fup-label inline-blk p-top-10">{{fileuploadLabel}}</label>
                                    <div class="loader inline-blk m-top-10" v-if ="loaderStatus">
                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                                        <rect x="0" y="10" width="4" height="10" fill="#333" opacity="0.2">
                                            <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0s" dur="0.6s" repeatCount="indefinite" />
                                            <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
                                            <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
                                        </rect>
                                        <rect x="8" y="10" width="4" height="10" fill="#333"  opacity="0.2">
                                            <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                                            <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                                            <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                                        </rect>
                                        <rect x="16" y="10" width="4" height="10" fill="#333"  opacity="0.2">
                                            <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                                            <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                                            <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                                        </rect>
                                    </svg>
                                </div>
                                </grid-item>
                                <grid-item size="2/6" class="dash-form-fileup-btn m-top-10">
                                    <label v-bind:class="fileuploadlabelcls" id="logofilebtn">{{fileBtnLabel}}
                                        <!-- <input v-model="appdesc" v-validate.initial="appdesc" data-vv-rules="required" type="file" name="fileup" value="" :class="{'has-error': errors.has('appdesc') }"> -->
                                        <input type="file" id="fileup" name="fileup" @change="fileUpload">
                                    </label>

                                </grid-item>
                            </grid>

                        </div>
                        <!-- <label class="dash-form-label">Select use case of {{appname}}</label> -->

                    </grid-item>
                </grid>

                <grid horizontal="middle" class="dash-form-ele m-top-30">
                    <grid-item size="3/12">
                    </grid-item>
                    <grid-item size="6/12">
                        <label class="dash-form-label">Select template for <strong>{{appname}}</strong></label>
                        <grid class="m-top-10">
                            <grid-item size="2/6" style="margin-right:22%">
                                <label class="control control--radio dash-form-chk-label">Casual
                                    <input type="radio" name="mode" value="Casual" checked="checked" @click="themeChange('casual')"/>
                                    <div class="control__indicator"></div>
                                </label>
                                <div class="dash-template-box casual-light" id="casualimg">
                                    <div class="magnifier-thumb-wrapper demo">
                                        <img id="thumb-inside" src="../assets/images/casual-light.png" width="258px" height="221px" data-large-img-url="https://vlite.mobiotics.com/largeimage/casual-light-large.jpg" data-mode="inside" data-zoomable="true" style="opacity:0">
                                    </div>
                                    <!-- <a class="magnifier-thumb-wrapper demo" href="#" id="casualimg">
                                    </a> -->
                                </div>
                            </grid-item>

                            <grid-item size="2/6">
                                <label class="control control--radio dash-form-chk-label">Modern
                                    <input type="radio" name="mode" value="Modern" @click="themeChange('modern')"/>
                                    <div class="control__indicator"></div>
                                </label>
                                <div class="dash-template-box modern-light" id="modernimg">
                                    <div class="magnifier-thumb-wrapper demo">
                                        <img id="thumb-modern-inside" src="../assets/images/modern-light.png" width="258px" height="221px" data-large-img-url="https://vlite.mobiotics.com/largeimage/modern-light-large.jpg" data-mode="inside" data-zoomable="true" style="opacity:0">
                                    </div>
                                </div>
                                <!-- <div class="dash-template-box modern-light" id="modernimg">

                                </div> -->
                            </grid-item>

                        </grid>
                    </grid-item>
                </grid>

                <grid horizontal="middle" class="dash-form-ele">
                    <grid-item size="3/12">
                    </grid-item>
                    <grid-item size="6/12">
                        <grid>
                            <grid-item size="2/6" style="margin-right:22%">
                                <div id="properties1" class="property">
                                    <label class="dash-label dash-label-light">Light</label>
                                    <div class="inline-blk ld-toggle" id="casual-con">
                                        <input type="checkbox" id="casual" name="casualtheme" class="cbx hidden" @click="changecasualtheme"/>
                                        <label for="casual" class="lbl"></label>
                                    </div>
                                    <label class="dash-label dash-label-dark">Dark</label>
                                </div>
                            </grid-item>

                            <grid-item size="2/6">
                                <div id="properties2" class="property">
                                    <label class="dash-label dash-label-light">Light</label>
                                    <div class="inline-blk ld-toggle" id="modern-con">
                                        <input type="checkbox" id="modern" name="moderntheme" class="cbx hidden width-100" @click="changemodrentheme" disabled='true'/>
                                        <label for="modern" class="lbl"></label>
                                    </div>
                                    <label class="dash-label dash-label-dark">Dark</label>
                                </div>
                            </grid-item>
                        </grid>
                    </grid-item>
                </grid>

                <grid horizontal="middle" class="dash-form-ele m-top-80">
                    <grid-item size="3/12">
                    </grid-item>
                    <grid-item size="6/12">
                        <label class="dash-form-label">Connect <strong>{{appname}}</strong> social handles</label>
                        <div>
                            <div v-bind:class="dashiconinput">
                                <icon scale="1.1" name="facebook"></icon> /
                            </div>
                            <input type="text" class="dash-form-text-val width-100" id="fb" name="fb" value="">
                        </div>

                        <div>
                            <div v-bind:class="dashiconinput">
                                <icon scale="1.1" name="google-plus"></icon> /
                            </div>
                            <input type="text" class="dash-form-text-val width-100" id="gp" name="gp" value="">
                        </div>

                        <div>
                            <div v-bind:class="dashiconinput">
                                <icon scale="1.1" name="twitter"></icon> /
                            </div>
                            <input type="text" class="dash-form-text-val width-100" id="tw" name="tw" value="">
                        </div>
                    </grid-item>
                </grid>

            </container>
        </div>

        <div v-bind:class="dashadmininfo">
            <container id="admininfobox">
                <p class="center dash-form-head">ADMIN INFORMATION</p>
                <div class="clearfix"></div>
                <grid horizontal="middle" class="dash-form-ele">
                    <grid-item size="3/12">
                    </grid-item>
                    <grid-item size="6/12">
                        <div class="form-group" :class="{'has-error': errors.has('name') }">
                            <label class="dash-form-label" for="name">Tell us your name</label><span class="text-danger">*</span>
                            <input v-model="name" v-validate.initial="name" data-vv-rules="required|max:45" class="dash-form-text-val m-top-10 white width-100" type="text" id="vendorname" name="vendorname" maxlength="44" value="" :class="{'has-error': errors.has('name') }">
                        </div>
                        <!-- <label class="dash-form-label">Tell us your name</label>
                        <input type="text" class="dash-form-text-val m-top-10" name="" value=""> -->
                    </grid-item>
                </grid>
                <grid horizontal="middle" class="dash-form-ele" id="vendoremaildiv">
                    <grid-item size="3/12">
                    </grid-item>
                    <grid-item size="6/12">
                        <div class="form-group relative" :class="{'has-error': errors.has('email') }">
                            <label id="vendoremail-label" class="dash-form-label" for="name">Your email id</label><span class="text-danger">*</span>
                            <input v-model="email" v-validate.initial="email" data-vv-rules="required|email|max:64" class="dash-form-text-val m-top-10 white width-100" type="text" name="vendoremail" maxlength="64" id="vendoremail" value="" @blur="emailPrecheck" :class="{'has-error': errors.has('email') }">
                            <div class="email-spin" v-if ="emailspin">
                                <svg class="lds-spin" width="30px"  height="30px"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style="background: none;"><g transform="translate(80,50)">
                                <g transform="rotate(0)">
                                <circle cx="0" cy="0" r="10" fill="#EF307E" fill-opacity="1" transform="scale(1.045 1.045)">
                                  <animateTransform attributeName="transform" type="scale" begin="-0.8333333333333334s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                                  <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.8333333333333334s"></animate>
                                </circle>
                                </g>
                                </g><g transform="translate(65,75.98076211353316)">
                                <g transform="rotate(59.99999999999999)">
                                <circle cx="0" cy="0" r="10" fill="#FFCA37" fill-opacity="0.8333333333333334" transform="scale(1.06167 1.06167)">
                                  <animateTransform attributeName="transform" type="scale" begin="-0.6666666666666666s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                                  <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.6666666666666666s"></animate>
                                </circle>
                                </g>
                                </g><g transform="translate(35.00000000000001,75.98076211353316)">
                                <g transform="rotate(119.99999999999999)">
                                <circle cx="0" cy="0" r="10" fill="#3BD7DC" fill-opacity="0.6666666666666666" transform="scale(1.07833 1.07833)">
                                  <animateTransform attributeName="transform" type="scale" begin="-0.5s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                                  <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.5s"></animate>
                                </circle>
                                </g>
                                </g><g transform="translate(20,50.00000000000001)">
                                <g transform="rotate(180)">
                                <circle cx="0" cy="0" r="10" fill="#EF307E" fill-opacity="0.5" transform="scale(1.095 1.095)">
                                  <animateTransform attributeName="transform" type="scale" begin="-0.3333333333333333s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                                  <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.3333333333333333s"></animate>
                                </circle>
                                </g>
                                </g><g transform="translate(34.999999999999986,24.019237886466847)">
                                <g transform="rotate(239.99999999999997)">
                                <circle cx="0" cy="0" r="10" fill="#FFCA37" fill-opacity="0.3333333333333333" transform="scale(1.01167 1.01167)">
                                  <animateTransform attributeName="transform" type="scale" begin="-0.16666666666666666s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                                  <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.16666666666666666s"></animate>
                                </circle>
                                </g>
                                </g><g transform="translate(65,24.019237886466843)">
                                <g transform="rotate(300.00000000000006)">
                                <circle cx="0" cy="0" r="10" fill="#3BD7DC" fill-opacity="0.16666666666666666" transform="scale(1.02833 1.02833)">
                                  <animateTransform attributeName="transform" type="scale" begin="0s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                                  <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="0s"></animate>
                                </circle>
                                </g>
                                </g></svg>
                            </div>

                        </div>
                        <!-- <label class="dash-form-label">Your email id</label>
                        <input type="text" class="dash-form-text-val m-top-10" name="" value=""> -->
                    </grid-item>
                </grid>
                <grid horizontal="middle" class="dash-form-ele">
                    <grid-item size="3/12">
                    </grid-item>
                    <grid-item size="6/12">
                        <div class="form-group" :class="{'has-error': errors.has('number') }">
                            <label class="dash-form-label" for="number">Mobile number which we can contact you</label><span class="text-danger">*</span>
                            <input v-model="number" v-validate.initial="number" data-vv-rules="required|numeric|min:10|max:20" class="dash-form-text-val m-top-10 white width-100" type="text" name="phone" id="phone" value="" :class="{'has-error': errors.has('number') }">
                        </div>
                        <!-- <label class="dash-form-label">Mobile number which we can contact you</label>
                        <input type="text" class="dash-form-text-val m-top-10" name="" value=""> -->
                    </grid-item>
                </grid>
                <grid horizontal="middle" class="dash-form-ele">
                    <grid-item size="3/12">
                    </grid-item>
                    <grid-item size="6/12">
                        <div class="form-group" :class="{'has-error': errors.has('password') }">
                            <label class="dash-form-label" for="password">Let us set a password</label><span class="text-danger">*</span>
                            <input v-model="password" v-validate.initial="password" data-vv-rules="required|max:25|verify_password" class="dash-form-text-val m-top-10 white width-100" type="password" name="password" id="password" value="" :class="{'has-error': errors.has('password') }">
                            <label id="password-label" class="label-txt-error" :class="{'has-error-label-active': errors.has('password') }">password contain atleast one uppercase, one lowercase, one special character and number, min length 8 </label>
                        </div>
                        <!-- <label class="dash-form-label">Let us set a password</label>
                        <input type="text" class="dash-form-text-val m-top-10" name="" value=""> -->
                    </grid-item>
                </grid>
                <grid horizontal="middle" class="dash-form-ele">
                    <grid-item size="3/12">
                    </grid-item>
                    <grid-item size="6/12">
                        <div class="form-group" :class="{'has-error': errors.has('cpassword') }">
                            <label class="dash-form-label" for="cpassword">And confirm your password</label><span class="text-danger">*</span>
                            <input v-model="cpassword" v-validate.initial="cpassword" data-vv-rules="required|confirmed:password|max:25" data-vv-as="password" class="dash-form-text-val m-top-10 white width-100" type="password" id="cpassword" name="cpassword" value="" :class="{'has-error': errors.has('cpassword') }">
                        </div>
                        <!-- <label class="dash-form-label">And confirm your password</label>
                        <input type="text" class="dash-form-text-val m-top-10" name="" value=""> -->
                    </grid-item>
                </grid>
                <grid horizontal="middle" class="dash-form-ele">
                    <grid-item size="3/12">
                    </grid-item>
                    <grid-item size="6/12">
                        <div class="form-group" :class="{'has-error': errors.has('supportemail') }">
                            <label class="dash-form-label" for="supportemail">Support Email</label><span class="text-danger">*</span>
                            <input v-model="supportemail" v-validate.initial="supportemail" data-vv-rules="required|max:64|email" class="dash-form-text-val m-top-10 white width-100" type="text" id="supportemail" name="supportemail" maxlength="44" value="" :class="{'has-error': errors.has('supportemail') }">
                        </div>
                        <!-- <label class="dash-form-label">Tell us your name</label>
                        <input type="text" class="dash-form-text-val m-top-10" name="" value=""> -->
                    </grid-item>
                </grid>
                <grid horizontal="middle" class="dash-form-ele">
                    <grid-item size="3/12">
                    </grid-item>
                    <grid-item size="6/12">
                        <div class="form-group">
                            <label class="dash-form-label" for="website">Enter website name for <strong>{{appname}}</strong> (Optional)</label>
                            <!-- <label class="dash-form-label">Select use case of {{appname}}</label> -->
                            <grid class="m-top-10" id="urldiv">
                                <!-- <grid-item size="1/6" style="margin-top:0.3rem">
                                    <label class="control control--radio dash-form-chk-label">No
                                        <input type="radio" name="link" value="No" @click="reseturldata('NO')"/>
                                        <div class="control__indicator"></div>
                                    </label>
                                </grid-item>
                                <grid-item size="1/6" style="margin-top:0.3rem">
                                    <label class="control control--radio dash-form-chk-label">Yes
                                        <input type="radio" name="link" value="Yes" checked="checked" @click="reseturldata('YES')"/>
                                        <div class="control__indicator"></div>
                                    </label>
                                </grid-item> -->
                                <grid-item >
                                    <input v-model="website" v-validate.initial="website" data-vv-rules="max:256"  class="dash-form-text-val dash-form-url left white width-100" type="text" name="website" value="" id="url" placeholder="Website URL">
                                    <!-- <input v-model="website" v-validate.initial="website" data-vv-rules="url"  class="ash-form-text-val dash-form-url left white" type="text" name="" value="" :class="{'has-error': errors.has('website') }"> -->
                                    <!-- <input type="text" class="dash-form-text-val dash-form-url left white" name="" value="" placeholder="URL"> -->
                                    <span style="font-size:12px;color:#f15f79;">You need to procure and provide SSL certificate for this domain. <strong>Do not fill</strong> if not required</span>
                                </grid-item>
                            </grid>
                        </div>
                    </grid-item>
                </grid>

                <div v-if ="customopt">
                    <p class="center dash-form-head">CUSTOM OPTIONS</p>

                    <grid horizontal="middle" class="dash-form-ele">
                        <grid-item size="3/12">
                        </grid-item>
                        <grid-item size="6/12">
                            <label class="dash-form-label">Do you want <strong>course levels</strong> to be enabled
                                <span class="f-right" @mouseover="mouselog('enter','levelenablediv')" @mouseleave="mouselog('leave','levelenablediv')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                                      <g fill="none" fill-rule="evenodd">
                                        <circle cx="7.5" cy="7.5" r="7.5" fill="#E1E1E1"/>
                                        <path fill="#666" d="M5.238,5.37 C5.27000016,4.72199676 5.48999796,4.22000178 5.898,3.864 C6.30600204,3.50799822 6.84599664,3.33 7.518,3.33 C8.19000336,3.33 8.73199794,3.49399836 9.144,3.822 C9.55600206,4.15000164 9.762,4.62199692 9.762,5.238 C9.762,5.55000156 9.7120005,5.82399882 9.612,6.06 C9.5119995,6.29600118 9.38800074,6.4939992 9.24,6.654 C9.09199926,6.8140008 8.8980012,6.99799896 8.658,7.206 C8.31399828,7.49400144 8.05400088,7.76399874 7.878,8.016 C7.70199912,8.26800126 7.614,8.58999804 7.614,8.982 L6.966,8.982 C6.966,8.65399836 7.0159995,8.3700012 7.116,8.13 C7.2160005,7.8899988 7.33799928,7.6900008 7.482,7.53 C7.62600072,7.3699992 7.81399884,7.190001 8.046,6.99 C8.27000112,6.789999 8.4419994,6.62400066 8.562,6.492 C8.6820006,6.35999934 8.78399958,6.19800096 8.868,6.006 C8.95200042,5.81399904 8.994,5.59000128 8.994,5.334 C8.994,4.90199784 8.85600138,4.5760011 8.58,4.356 C8.30399862,4.1359989 7.93000236,4.026 7.458,4.026 C6.98599764,4.026 6.61400136,4.14199884 6.342,4.374 C6.06999864,4.60600116 5.92200012,4.94599776 5.898,5.394 L5.238,5.37 Z M7.278,10.578 C7.43000076,10.578 7.55799948,10.6299995 7.662,10.734 C7.76600052,10.8380005 7.818,10.9659992 7.818,11.118 C7.818,11.2700008 7.76600052,11.3999995 7.662,11.508 C7.55799948,11.6160005 7.43000076,11.67 7.278,11.67 C7.12599924,11.67 7.0000005,11.6180005 6.9,11.514 C6.7999995,11.4099995 6.75,11.2780008 6.75,11.118 C6.75,10.9659992 6.7999995,10.8380005 6.9,10.734 C7.0000005,10.6299995 7.12599924,10.578 7.278,10.578 Z"/>
                                      </g>
                                    </svg>
                                </span>
                            </label>
                            <div class="custom-option-msg hidden" id="levelenablediv">
                                <p style="padding:0 10px;font-weight: 500;">Used to enable multiple levels in case you want to segregate students based on difficulty or student grade . If you enable this option, students will need to select a level on signup and will be able to progress level by level. You would need to specify course level for each course. </p>
                            </div>
                            <grid class="m-top-10">
                                <grid-item size="1/6" class="">
                                    <label class="control control--radio dash-form-chk-label">NO
                                        <input type="radio" name="levelenabled" value="NO" checked="checked"/>
                                        <div class="control__indicator"></div>
                                    </label>
                                </grid-item>
                                <grid-item size="1/6" class="dash-form-chk">
                                    <label class="control control--radio dash-form-chk-label">YES
                                        <input type="radio" name="levelenabled" value="YES"/>
                                        <div class="control__indicator"></div>
                                    </label>
                                </grid-item>
                            </grid>
                        </grid-item>
                    </grid>
                    <grid horizontal="middle" class="dash-form-ele">
                        <grid-item size="3/12">
                        </grid-item>
                        <grid-item size="6/12">
                            <label class="dash-form-label">Do you want <strong>institute options</strong> to be enabled
                                <span class="f-right" @mouseover="mouselog('enter','instituteenableddiv')" @mouseleave="mouselog('leave','instituteenableddiv')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                                      <g fill="none" fill-rule="evenodd">
                                        <circle cx="7.5" cy="7.5" r="7.5" fill="#E1E1E1"/>
                                        <path fill="#666" d="M5.238,5.37 C5.27000016,4.72199676 5.48999796,4.22000178 5.898,3.864 C6.30600204,3.50799822 6.84599664,3.33 7.518,3.33 C8.19000336,3.33 8.73199794,3.49399836 9.144,3.822 C9.55600206,4.15000164 9.762,4.62199692 9.762,5.238 C9.762,5.55000156 9.7120005,5.82399882 9.612,6.06 C9.5119995,6.29600118 9.38800074,6.4939992 9.24,6.654 C9.09199926,6.8140008 8.8980012,6.99799896 8.658,7.206 C8.31399828,7.49400144 8.05400088,7.76399874 7.878,8.016 C7.70199912,8.26800126 7.614,8.58999804 7.614,8.982 L6.966,8.982 C6.966,8.65399836 7.0159995,8.3700012 7.116,8.13 C7.2160005,7.8899988 7.33799928,7.6900008 7.482,7.53 C7.62600072,7.3699992 7.81399884,7.190001 8.046,6.99 C8.27000112,6.789999 8.4419994,6.62400066 8.562,6.492 C8.6820006,6.35999934 8.78399958,6.19800096 8.868,6.006 C8.95200042,5.81399904 8.994,5.59000128 8.994,5.334 C8.994,4.90199784 8.85600138,4.5760011 8.58,4.356 C8.30399862,4.1359989 7.93000236,4.026 7.458,4.026 C6.98599764,4.026 6.61400136,4.14199884 6.342,4.374 C6.06999864,4.60600116 5.92200012,4.94599776 5.898,5.394 L5.238,5.37 Z M7.278,10.578 C7.43000076,10.578 7.55799948,10.6299995 7.662,10.734 C7.76600052,10.8380005 7.818,10.9659992 7.818,11.118 C7.818,11.2700008 7.76600052,11.3999995 7.662,11.508 C7.55799948,11.6160005 7.43000076,11.67 7.278,11.67 C7.12599924,11.67 7.0000005,11.6180005 6.9,11.514 C6.7999995,11.4099995 6.75,11.2780008 6.75,11.118 C6.75,10.9659992 6.7999995,10.8380005 6.9,10.734 C7.0000005,10.6299995 7.12599924,10.578 7.278,10.578 Z"/>
                                      </g>
                                    </svg>
                                </span>
                            </label>
                            <div class="custom-option-msg hidden" id="instituteenableddiv">
                                <p style="padding:0 10px;font-weight: 500;">Used to onboard students from specific institutes only. If you enable this option, users will need specify an institute on signup. You will need to create one or more institutes from the console. </p>
                            </div>
                            <grid class="m-top-10">
                                <grid-item size="1/6" class="">
                                    <label class="control control--radio dash-form-chk-label">NO
                                        <input type="radio" name="instituteenabled" value="MOOC" checked="checked"/>
                                        <div class="control__indicator"></div>
                                    </label>
                                </grid-item>
                                <grid-item size="1/6" class="dash-form-chk">
                                    <label class="control control--radio dash-form-chk-label">YES
                                        <input type="radio" name="instituteenabled" value="YES"/>
                                        <div class="control__indicator"></div>
                                    </label>
                                </grid-item>
                            </grid>
                        </grid-item>
                    </grid>
                    <grid horizontal="middle" class="dash-form-ele">
                        <grid-item size="3/12">
                        </grid-item>
                        <grid-item size="6/12">
                            <label class="dash-form-label">Do you want <strong>entroll users</strong> to be enabled
                                <span class="f-right" @mouseover="mouselog('enter','bulkentrollenableddiv')" @mouseleave="mouselog('leave','bulkentrollenableddiv')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                                      <g fill="none" fill-rule="evenodd">
                                        <circle cx="7.5" cy="7.5" r="7.5" fill="#E1E1E1"/>
                                        <path fill="#666" d="M5.238,5.37 C5.27000016,4.72199676 5.48999796,4.22000178 5.898,3.864 C6.30600204,3.50799822 6.84599664,3.33 7.518,3.33 C8.19000336,3.33 8.73199794,3.49399836 9.144,3.822 C9.55600206,4.15000164 9.762,4.62199692 9.762,5.238 C9.762,5.55000156 9.7120005,5.82399882 9.612,6.06 C9.5119995,6.29600118 9.38800074,6.4939992 9.24,6.654 C9.09199926,6.8140008 8.8980012,6.99799896 8.658,7.206 C8.31399828,7.49400144 8.05400088,7.76399874 7.878,8.016 C7.70199912,8.26800126 7.614,8.58999804 7.614,8.982 L6.966,8.982 C6.966,8.65399836 7.0159995,8.3700012 7.116,8.13 C7.2160005,7.8899988 7.33799928,7.6900008 7.482,7.53 C7.62600072,7.3699992 7.81399884,7.190001 8.046,6.99 C8.27000112,6.789999 8.4419994,6.62400066 8.562,6.492 C8.6820006,6.35999934 8.78399958,6.19800096 8.868,6.006 C8.95200042,5.81399904 8.994,5.59000128 8.994,5.334 C8.994,4.90199784 8.85600138,4.5760011 8.58,4.356 C8.30399862,4.1359989 7.93000236,4.026 7.458,4.026 C6.98599764,4.026 6.61400136,4.14199884 6.342,4.374 C6.06999864,4.60600116 5.92200012,4.94599776 5.898,5.394 L5.238,5.37 Z M7.278,10.578 C7.43000076,10.578 7.55799948,10.6299995 7.662,10.734 C7.76600052,10.8380005 7.818,10.9659992 7.818,11.118 C7.818,11.2700008 7.76600052,11.3999995 7.662,11.508 C7.55799948,11.6160005 7.43000076,11.67 7.278,11.67 C7.12599924,11.67 7.0000005,11.6180005 6.9,11.514 C6.7999995,11.4099995 6.75,11.2780008 6.75,11.118 C6.75,10.9659992 6.7999995,10.8380005 6.9,10.734 C7.0000005,10.6299995 7.12599924,10.578 7.278,10.578 Z"/>
                                      </g>
                                    </svg>
                                </span>
                            </label>
                            <div class="custom-option-msg hidden" id="bulkentrollenableddiv">
                                <p style="padding:0 10px;font-weight: 500;">Used to restrict user enrollment to the app through console only. If you enable this option, you will need to bulk enroll users through console. Users shall get mail with user Id and Password with which they can login to the app. </p>
                            </div>
                            <grid class="m-top-10">
                                <grid-item size="1/6" class="">
                                    <label class="control control--radio dash-form-chk-label">NO
                                        <input type="radio" name="bulkenrollenabled" value="NO" checked="checked"/>
                                        <div class="control__indicator"></div>
                                    </label>
                                </grid-item>
                                <grid-item size="1/6" class="dash-form-chk">
                                    <label class="control control--radio dash-form-chk-label">YES
                                        <input type="radio" name="bulkenrollenabled" value="YES"/>
                                        <div class="control__indicator"></div>
                                    </label>
                                </grid-item>
                            </grid>
                        </grid-item>
                    </grid>
                </div>


            </container>
        </div>

        <div class="dashboard-billing-info dashboard-back-color" id="billingdiv">
            <container class="dashboard-billing-info-con">
                <p class="center dash-form-head">BILLING INFORMATION</p>
                <div class="clearfix"></div>
                <grid horizontal="middle" class="dash-form-ele">
                    <grid-item size="3/12">
                    </grid-item>
                    <grid-item size="9/12">
                        <label class="dash-form-label">Select billing period</label>
                        <grid class="m-top-20">
                            <grid-item size="3/6">
                                <div class="radio">
                                    <label class="control control--radio dash-form-chk-label">Annually <span class="dash-amt-strike">
                                    ${{planData.yearlyprice/100}}</span>${{planData.yearlydiscountedprice/100}}
                                        <input type="radio" name="renewperiod" value="YEAR" checked="checked"/>
                                        <div class="control__indicator"></div>
                                    </label>
                                </div>
                            </grid-item>

                            <grid-item size="3/6">
                                <div class="radio">
                                    <label class="control control--radio dash-form-chk-label">Monthly ${{planData.monthlydiscountedprice/100}}
                                        <input type="radio" name="renewperiod" value="MONTH"/>
                                        <div class="control__indicator"></div>
                                    </label>
                                </div>
                            </grid-item>
                        </grid>
                    </grid-item>
                </grid>
                <grid horizontal="middle" class="dash-form-ele center m-top-40">
                    <grid-item size="3/12">
                    </grid-item>
                    <grid-item size="6/12">
                        <label class="dash-form-text center">All Set. Please click the blue button below to bring <strong>{{appname}}</strong> online.</label>
                    </grid-item>
                </grid>
                <grid horizontal="middle" class="dash-form-ele m-top-40 m-bot-40">
                    <grid-item size="3/12">
                    </grid-item>
                    <grid-item size="6/12 ">
                        <label class="control control--checkbox">
                            <input type="checkbox" name="agree" id="agree"/>
                            <div class="control__indicator" id="terms"></div>
                        </label>
                        <label class="dash-form-label width-100">I agree to <strong> Terms and Conditions </strong>and <strong>Privacy policy.</strong></label>
                    </grid-item>
                </grid>
                <div class="center">
                    <button type="button" class="btn vl-btn dash-pay-btn raise" @click="checkout">PROCEED TO PAYMENT</button>
                </div>

            </container>
            <input type="hidden" id="cctoken" name="cctoken" value="" />
            <input type="hidden" id="keepcardonfile" name="keepcardonfile" v-bind:value="keepcardonfile" />
            <!-- Address -->
            <input type="hidden" id="addressLine" name="addressLine" value="" />
            <input type="hidden" id="addressCity" name="addressCity" value="" />
            <input type="hidden" id="addressCountry" name="addressCountry" value="" />
            <input type="hidden" id="addressPincode" name="addressPincode" value="" />
            <input type="submit" id="FbtnSubmit" class="hidden"/>
        </div>
    </form>
        <!--Footer-->
        <footer class="page-footer">
            <div class="footer-color">
                <container>
                    <grid>
                        <grid-item size="4/12">
                            <div class="vl-foot-left">
                                <div class=" logo-opacity">
                                    <!-- <img class="v-middle" src="../assets/images/v-lite-white-logo.svg"><span class="logo-text">vLite</span> -->
                                    <img class="v-middle" src="../assets/images/logo_white.svg" style="width:20%;">
                                </div>
                            <p class="foot-copy">&copy; Copyright <label id="copyrightyear"></label><a href="https://www.mobiotics.com" target="_blank">
                                <img class="v-middle foot-cmp-logo" src="../assets/images/mobiotics-logo-horizontal.svg"></a></p>

                            </div>
                        </grid-item>
                        <grid-item size="4/12">
                            <div class="vl-foot-mid">
                                <ul>
                                    <li><a @click="openSocialNewTab('https://www.facebook.com/mobiotics')"><icon scale="1.2" class="white-text" name="facebook"></icon></a></li>
                                    <li><a @click="openSocialNewTab('https://plus.google.com/106588943035549674608/posts')"><icon scale="1.5" class="white-text" name="google-plus"></icon></a></li>
                                    <li><a @click="openSocialNewTab('https://twitter.com/mobiotics')"><icon scale="1.2" class="white-text" name="twitter"></icon></a></li>
                                </ul>
                            </div>
                        </grid-item>
                        <grid-item size="4/12">
                            <div class="vl-foot-right f-right">
                            <p class="foot-copy"><a href="#">Terms Of Use</a></p>
                            <p class="foot-copy"><a href="#">Privacy Policy</a></p>
                            </div>
                            <!-- <div class="vl-foot-right">
                                <ul>
                                    <li><a href="#">Terms of use</a></li>
                                    <li><a href="#">Privacy Policy</a></li>
                                </ul>
                            </div> -->
                        </grid-item>
                    </grid>
                </container>
            </div>
        </footer>
        <!-- basic -->
        <container>
            <div class="dash-loader" id="dash-loader" v-if ="mainloaderStatus">
                <div class="dash-loader-img">
                    <svg class="lds-spin" width="100px"  height="100px"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style="background: none;"><g transform="translate(80,50)">
                    <g transform="rotate(0)">
                    <circle cx="0" cy="0" r="10" fill="#EF307E" fill-opacity="1" transform="scale(1.045 1.045)">
                      <animateTransform attributeName="transform" type="scale" begin="-0.8333333333333334s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                      <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.8333333333333334s"></animate>
                    </circle>
                    </g>
                    </g><g transform="translate(65,75.98076211353316)">
                    <g transform="rotate(59.99999999999999)">
                    <circle cx="0" cy="0" r="10" fill="#FFCA37" fill-opacity="0.8333333333333334" transform="scale(1.06167 1.06167)">
                      <animateTransform attributeName="transform" type="scale" begin="-0.6666666666666666s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                      <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.6666666666666666s"></animate>
                    </circle>
                    </g>
                    </g><g transform="translate(35.00000000000001,75.98076211353316)">
                    <g transform="rotate(119.99999999999999)">
                    <circle cx="0" cy="0" r="10" fill="#3BD7DC" fill-opacity="0.6666666666666666" transform="scale(1.07833 1.07833)">
                      <animateTransform attributeName="transform" type="scale" begin="-0.5s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                      <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.5s"></animate>
                    </circle>
                    </g>
                    </g><g transform="translate(20,50.00000000000001)">
                    <g transform="rotate(180)">
                    <circle cx="0" cy="0" r="10" fill="#EF307E" fill-opacity="0.5" transform="scale(1.095 1.095)">
                      <animateTransform attributeName="transform" type="scale" begin="-0.3333333333333333s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                      <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.3333333333333333s"></animate>
                    </circle>
                    </g>
                    </g><g transform="translate(34.999999999999986,24.019237886466847)">
                    <g transform="rotate(239.99999999999997)">
                    <circle cx="0" cy="0" r="10" fill="#FFCA37" fill-opacity="0.3333333333333333" transform="scale(1.01167 1.01167)">
                      <animateTransform attributeName="transform" type="scale" begin="-0.16666666666666666s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                      <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.16666666666666666s"></animate>
                    </circle>
                    </g>
                    </g><g transform="translate(65,24.019237886466843)">
                    <g transform="rotate(300.00000000000006)">
                    <circle cx="0" cy="0" r="10" fill="#3BD7DC" fill-opacity="0.16666666666666666" transform="scale(1.02833 1.02833)">
                      <animateTransform attributeName="transform" type="scale" begin="0s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform>
                      <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="0s"></animate>
                    </circle>
                    </g>
                    </g>
                </svg>
                </div>
            </div>
    </container>
    </div>



</template>

<style>
@import "../assets/css/magnifier.css";
</style>

<script>
const { EventJS } = require('../assets/js/Event.js');
const { MagnifierJS } = require('../assets/js/Magnifier.js');
const { Config } = require('../assets/js/config.js');
import FixedHeader from 'vue-fixed-header';
    export default{
        components: { ele: '#signupform', 'fixed-header': FixedHeader},
        data(){
            return{
                showModal: false,
                planData:{},
                formSubmitted: false,
                appname:"",
                appdesc:"",
                name:"",
                supportemail:"",
                email:"",
                emailokflag:true,
                number:"",
                password:"",
                cpassword:"",
                website:"",
                hasurlvalidation: 'required',
                fileuploadLabel: "PNG (recommended 1024x1024 px)",
                loaderStatus:false,
                mainloaderStatus:false,
                fileBtnLabel:'SELECT FILE',
                dashbasicinfo: ['dashboard-basic','dashboard-back-color'],
                dashadmininfo: 'dashboard-admin-info',
                dashiconinput: 'dash-input-icon',
                filename:'',
                keepcardonfile:'NO',
                renewperiod: 'YEAR',
                logo:'',
                fileuploadlabelcls: 'dash-form-fileup',
                priorplan:'',
                priorplanname:false,
                backupPlan:{},
                skipplanname:'',
                higherplanstatus:false,
                lowerplanstatus:false,
                emailspin:false,
                userdata:{},
                apibaseurl:'',
                vendorportalurl:'',
                stripelogo:'',
                largeimagepath:'',
                normaldevice: true,
                smalldevice: false,
                isFixed: false,
                showfixedheader: false,
                sidebarVisible: false,
                seltype:'',
                customopt:false
            };
        },
        created () {
            this.screenResize();
            this.planData = this.$route.params.plandata;
            this.priorplan = this.$route.params.priorplan;
            this.seltype = this.$route.params.seltype;
            //console.log(this.priorplan);
            if ((this.planData === undefined) && (this.priorplan === undefined)) {
                if (localStorage.getItem("planobj") === null) {
                  this.navigateToHomeWithDiv('plans');
              }else{
                  // Retrieve the object from storage
                  var planObject = localStorage.getItem('planobj');
                  this.planData = JSON.parse(planObject);
                  if (localStorage.getItem("priorplanobj") != null) {
                    var priorplanObject = localStorage.getItem('priorplanobj');
                    this.priorplan = JSON.parse(priorplanObject);
                    this.higherplanstatus = true;
                  }
                  this.seltype=localStorage.getItem('seltype');
                  this.userdata = this.$route.params.userdata;
              }
          }else if(this.planData != ''){
                //Remove exsisting plans
                localStorage.removeItem('planobj');
                localStorage.removeItem('priorplanobj');
                localStorage.removeItem('seltype');
                // Put the object into storage
                localStorage.setItem('planobj', JSON.stringify(this.planData));
                if(this.priorplan == ''){
                    this.priorplanname = this.planData.planname;
                }else{
                    // Put the object into storage
                    localStorage.setItem('priorplanobj', JSON.stringify(this.priorplan));
                    this.priorplanname = this.priorplan.planname;
                    this.higherplanstatus = true;
                }
                localStorage.setItem('seltype', this.seltype);
            }else{


            }
            //console.log(this.planData);
            document.getElementById('app').scrollIntoView();
            // this.dynamicClass = 'c100 p10 big';
            // this.percent=10;
        },
        mounted() {
            // Setting Config URLs
            var con = new Config()
            this.apibaseurl = con.getApiUrl();
            this.vendorportalurl = con.getPortalUrl();
            this.stripelogo = con.getStripeLogo();
            this.largeimagepath = con.getlargeImgPath();

            var evt = new EventJS(),
                mg = new MagnifierJS(evt, {
                    largeWrapper: document.getElementById('casualimg')
                });
                mg.attach({
                    thumb: '#thumb-inside',
                    // large: 'https://www.research.bayer.com/img/facebook/27/wissenschaft-facebook-1200x1200.jpg',
                    largeWrapper: 'preview',
                    zoom: 3,
                    zoomable: false
                });

                var evtm = new EventJS(),
                    mgm = new MagnifierJS(evtm, {
                        largeWrapper: document.getElementById('modernimg')
                    });
                    mg.attach({
                        thumb: '#thumb-modern-inside',
                        // large: 'https://www.research.bayer.com/img/facebook/27/wissenschaft-facebook-1200x1200.jpg',
                        largeWrapper: 'preview',
                        zoom: 3,
                        zoomable: false
                    });


            let self = this;
            window.addEventListener('scroll', function(e) {
                // console.log('came');
                let wheight = window.pageYOffset;
                let x = document.querySelector('#headerelement').clientHeight;
                // console.log(wheight+'  '+x);
                let tlimit = x+120;
                if(x < wheight){
                    self.showfixedheader = true;
                    // console.log('show f header');
                }else{
                    self.showfixedheader = false;
                    // console.log('show n header');
                }
            });

            // document.gambitGalleryIsInView = function( el ) {
            // 	var viewport = {};
            //     viewport.top = window.pageYOffset;
            //     viewport.bottom = viewport.top + window.innerHeight;
            //
            //     var bounds = {};
            // 	bounds.top = el.getBoundingClientRect().top + window.pageYOffset
            // 	bounds.bottom = bounds.top + el.clientHeight;
            //
            // 	return (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom)
            // 		|| (bounds.top <= viewport.bottom && bounds.top >= viewport.top );
            // };
            console.log(this.seltype);
            var inputElements = document.getElementsByName("type");
            for(var i=0; inputElements[i]; ++i){
                    if(inputElements[i].value == (this.seltype)){
                        inputElements[i].checked = true;
                        break;
                    }
                }

            this.customoptionshow();

            var thisYear  = new Date().getFullYear();
            // console.log(document.getElementById('copyrightyear'));
            document.getElementById('copyrightyear').innerHTML = thisYear;

            this.restoreData();
        },
        watch: {
            '$mq.resize': 'screenResize'
        },
        methods: {
            mouselog(action,id){
                if(action == 'enter'){
                    var des = document.getElementById(id);
                    if(!document.getElementById(id).className.split(" ").indexOf("hidden") >= 0) {
                        // des.className += " casual-dark";
                        des.classList.remove("hidden");
                    }
                }

                if(action == 'leave'){
                    var des = document.getElementById(id);
                    if(!document.getElementById(id).className.split(" ").indexOf("hidden") <= 0) {
                        des.className += " hidden";
                        // des.classList.remove("hidden");
                    }
                }

            },
            customoptionshow(){
                if(this.seltype == 'MOOC'){
                    if(this.planData.planname == 'STARTER'){
                        this.customopt = false;
                    }else{
                        this.customopt = true;
                    }
                }
            },
            toggleSidebar () {
                this.sidebarVisible = !this.sidebarVisible;
            },
            screenResize() {
                var scsize = screen.width;
                console.log(scsize);
                if((scsize >= 1200)){
                    this.normaldevice= true;
                    this.smalldevice= false;
                }
                else if((scsize <= 1199) && (scsize >= 768)){
                    this.fileuploadlabelcls = 'dash-form-fileup-tab';
                    this.dashbasicinfo =  ['dashboard-basic','dashboard-back-color'];
                    this.dashadmininfo = 'dashboard-admin-info';
                    this.normaldevice= true;
                    this.smalldevice= false;
                }else if ((scsize <= 767) && (scsize >= 601)) {
                    this.fileuploadlabelcls = 'dash-form-fileup-tab';
                    this.dashbasicinfo =  ['dashboard-basic-plain','dashboard-back-color'];
                    this.dashadmininfo = 'dashboard-admin-info-plain';
                    this.dashiconinput = 'dash-input-icon-tab';
                    this.normaldevice= true;
                    this.smalldevice= false;
                }else if ((scsize <= 600) && (scsize >= 481)) {
                    this.fileuploadlabelcls = 'dash-form-fileup-tab';
                    this.dashbasicinfo =  ['dashboard-basic-plain','dashboard-back-color'];
                    this.dashadmininfo = 'dashboard-admin-info-plain';
                    this.dashiconinput = 'dash-input-icon-tab';
                    this.normaldevice= false;
                    this.smalldevice= true;

                }else if ((scsize <= 480) ) {
                    this.fileuploadlabelcls = 'dash-form-fileup-mob';
                    this.dashbasicinfo =  ['dashboard-basic-plain','dashboard-back-color'];
                    this.dashadmininfo = 'dashboard-admin-info-plain';
                    this.dashiconinput = 'dash-input-icon-tab';
                    this.normaldevice= false;
                    this.smalldevice= true;
                }
            },
            reseturldata(flag){
                if(flag == 'NO'){
                    document.getElementById("url").value = "";
                    this.userdata.url = "";
                    this.website = "";
                    document.getElementById('url').setAttribute("disabled", "true");
                }else{
                    document.getElementById('url').removeAttribute("disabled");
                }
            },
            checkout() {
              this.validateBeforeSubmit();
              if(this.formSubmitted){
                  var amount = this.planData.yearlydiscountedprice;
                  var inputElements = document.getElementsByName("renewperiod");

                  for(var i=0; inputElements[i]; ++i){
                      if(inputElements[i].checked){
                          console.log(inputElements[i].value);
                          if(inputElements[i].value == 'MONTH'){
                              amount = this.planData.monthlydiscountedprice;
                              this.renewperiod = 'MONTH';
                              console.log(amount);
                          }
                          break;
                      }
                  }


                  this.$checkout.open({
                      name: 'VLITE Purchase',
                      currency: 'USD',
                      amount: amount,
                      image: this.stripelogo,
                    //   shippingAddress: true,
                      billingAddress: true,
                      token(token) {
                        //   console.log(token);
                          document.getElementById('cctoken').value = token.id;
                         // document.getElementById('cctoken').value = 123456;
                          document.getElementById('addressLine').value = token.card.address_line1;
                          document.getElementById('addressCity').value = token.card.address_city;
                          document.getElementById('addressCountry').value = token.card.address_country;
                          document.getElementById('addressPincode').value = token.card.address_zip;
                         //document.getElementById('signupform').submit();
                         document.getElementById('FbtnSubmit').click();
                     }
                  });
              }else{
                //   console.log('Form Error');
              }
          },
          onFormSubmit: function (event) {
            this.mainloaderStatus = true;
            var token = document.getElementById('cctoken').value;
            if(token){
                this.keepcardonfile = 'YES';
            }
            var formData = new FormData();
            var userdata = new Object();
            //vendor mode checking
            var vendormode = 'LITE';
            var inputElements = document.getElementsByName("type");
            for(var i=0; inputElements[i]; ++i){
                if(inputElements[i].checked){
                    if(inputElements[i].value == 'MOOC'){
                        vendormode = 'MOOC';
                        break;
                    }
                }
            }
            // levelenabled
            var levelenabled = 'NO';
            var inputlevel = document.getElementsByName("levelenabled");
            for(var i=0; inputlevel[i]; ++i){
                if(inputlevel[i].checked){
                    if(inputlevel[i].value == 'YES'){
                        levelenabled = 'YES';
                        break;
                    }
                }
            }
            // institute enabled
            var instituteenabled = 'NO';
            var inputinstitute = document.getElementsByName("instituteenabled");
            for(var i=0; inputinstitute[i]; ++i){
                if(inputinstitute[i].checked){
                    if(inputinstitute[i].value == 'YES'){
                        instituteenabled = 'YES';
                        break;
                    }
                }
            }
            //bulk enabled
            var bulkentroll = 'NO';
            var inputbulk = document.getElementsByName("bulkenrollenabled");
            for(var i=0; inputbulk[i]; ++i){
                if(inputbulk[i].checked){
                    if(inputbulk[i].value == 'YES'){
                        bulkentroll = 'YES';
                        break;
                    }
                }
            }
            formData.append('logo',this.logo);
            formData.append('renewperiod',this.renewperiod);
            formData.append('planid',this.planData.planid);
            formData.append('vendormode', vendormode);
            formData.append('streamenabled', 'YES');
            formData.append('adenabled', 'NO');
            formData.append('paymentenabled', 'YES');
            formData.append('drmenabled', 'NO');
            formData.append('hdenabled', 'YES');
            formData.append('appname', 'YES');
            formData.append('instituteenabled', instituteenabled);
            formData.append('levelenabled', levelenabled);
            formData.append('bulkenrollenabled', bulkentroll);

            //extra info passing as a array
            var others = [];
            var appname = document.getElementById('appname').value;
            var appdesc = document.getElementById('appdesc').value;
            var fb = document.getElementById('fb').value;
            var gp = document.getElementById('gp').value;
            var tw = document.getElementById('tw').value;
            var addressLine = document.getElementById('addressLine').value;
            var addressCity = document.getElementById('addressCity').value;
            var addressCountry = document.getElementById('addressCountry').value;
            var addressPincode = document.getElementById('addressPincode').value;
            var contactno = document.getElementById('phone').value;
            //vendor mode checking
            var vendorAppMode = 'Casual';
            var vendorAppTheme = 'Light';
            var inputElements = document.getElementsByName("mode");
            for(var i=0; inputElements[i]; ++i){
                if(inputElements[i].checked){
                    if(inputElements[i].value == 'Modern'){
                        vendorAppMode = 'Modern';
                        break;
                    }
                }
            }
            if(vendorAppMode == 'Modern'){
                var lfckv = document.getElementById("modern").checked;
                if(lfckv){
                    vendorAppTheme = 'Dark';
                }
            }else{
                var lfckv = document.getElementById("casual").checked;
                if(lfckv){
                    vendorAppTheme = 'Dark';
                }
            }

            var vendorApp = vendorAppMode+' - '+vendorAppTheme;

            others.push({appname:appname, appdesc:appdesc, fb:fb, gp:gp, tw:tw, addressLine:addressLine, addressCity:addressCity, addressCountry:addressCountry, addressPincode:addressPincode, vendorApp:vendorApp, contactno:contactno});
            formData.append('other', JSON.stringify(others));
            //console.log(others);

            if(this.formSubmitted){
                var Form = document.getElementById("signupform");
                for (var i = 0; i < Form.elements.length; i++) {
                    var key = Form.elements[i].name;
                    if((key == "vendorname") || (key == "website") || (key == "password") || (key == "vendoremail") || (key == "cctoken") || (key == "keepcardonfile")){
                        formData.append(key, Form.elements[i].value);
                        // console.log(Form.elements[i].name+' : '+Form.elements[i].value);
                    }
                }

                var supportemail = document.getElementById('supportemail').value;
                formData.append('appname', appname);
                formData.append('supportemail', supportemail);

                for (var value of formData.values()) {
                   console.log(value);
                }

                //make object for payment roll backupPlan
                userdata.appname = appname;
                userdata.appdesc = appdesc;
                userdata.vendormode = vendormode;
                userdata.filename = this.filename;
                userdata.filetext = this.fileuploadLabel;
                userdata.logo = this.logo;
                userdata.mode = vendorAppMode;
                userdata.modetheme = vendorAppTheme;
                userdata.fb = fb;
                userdata.gp = gp;
                userdata.tw = tw;
                userdata.vendorname = document.getElementById('vendorname').value;
                userdata.vendoremail = document.getElementById('vendoremail').value;
                userdata.phone = document.getElementById('phone').value;
                userdata.password = document.getElementById('password').value;
                userdata.url = document.getElementById('url').value;
                userdata.supportemail = supportemail;
                userdata.renewperiod = this.renewperiod;
                //make object for payment roll backupPlan---End
                //  console.log(userdata);
                this.submitForm(formData,vendormode,userdata);
            }
        },
          navigateToHome() {
            this.$router.push('/');
          },
        navigateToHomeWithDiv(divname){
            this.toggleSidebar = false;
            this.$router.push({ name: 'Home', params: { divid: divname}});
        },
        changecasualtheme(){
            var casual = document.getElementById('casual');
            var des = document.getElementById('casualimg');
            // remove last appended lens
            var parent = document.getElementById("thumb-inside-lens");
            var child = document.getElementById("thumb-inside-large");
            if(child!=null){
                parent.removeChild(child);
            }
            if(casual.checked){
                var des = document.getElementById('casualimg');
                if(!document.getElementById('casualimg').className.split(" ").indexOf("casual-light") >= 0) {
                    des.className += " casual-dark";
                    des.classList.remove("casual-light");
                    // image zoom change
                    document.getElementById('thumb-inside').setAttribute("data-large-img-url", this.largeimagepath+"/casual-dark-large.jpg");
                }
            }else{
                var des = document.getElementById('casualimg');
                if(!document.getElementById('casualimg').className.split(" ").indexOf("casual-dark") >= 0) {
                    des.className += " casual-light";
                    des.classList.remove("casual-dark");
                    // image zoom change
                    // console.log('zoom change to unchecked');
                    document.getElementById('thumb-inside').setAttribute("data-large-img-url", this.largeimagepath+"/casual-light-large.jpg");
                }
            }
            var evt = new EventJS(),
            mgchk = new MagnifierJS(evt);
            mgchk.attach({
                thumb: '#thumb-inside',
                largeWrapper: 'preview',
                zoom: 3,
                zoomable: false
            });

        },
        changemodrentheme(){

            var casual = document.getElementById('modern');
            var des = document.getElementById('modernimg');
            // remove last appended lens
            var parent = document.getElementById("thumb-modern-inside-lens");
            var child = document.getElementById("thumb-modern-inside-large");
            if(child!=null){
                parent.removeChild(child);
            }
            if(casual.checked){
                    if(!document.getElementById('modernimg').className.split(" ").indexOf("modern-light") >= 0) {
                        des.className += " modern-dark";
                        des.classList.remove("modern-light");
                    // image zoom change
                    document.getElementById('thumb-modern-inside').setAttribute("data-large-img-url", this.largeimagepath+"/modern-dark-large.jpg");
                }
            }else{
                if(!document.getElementById('modernimg').className.split(" ").indexOf("modern-dark") >= 0) {
                    des.className += " modern-light";
                    des.classList.remove("modern-dark");
                    // image zoom change
                    // console.log('morden zoom change to unchecked');
                    document.getElementById('thumb-modern-inside').setAttribute("data-large-img-url", this.largeimagepath+"/modern-light-large.jpg");
                }
            }
            var evt = new EventJS(),
            mgchk = new MagnifierJS(evt);
            mgchk.attach({
                thumb: '#thumb-modern-inside',
                largeWrapper: 'preview',
                zoom: 3,
                zoomable: false
            });

        },
        validateBeforeSubmit(e) {
            var fileflag = true;
            this.$validator.validateAll();

            var filecls = document.getElementById("logofilebtn");
            if(this.filename == ""){
                //add file error class
                if(filecls.className.split(" ").indexOf("dash-form-fileup-error") <= 0) {
                    filecls.className += " dash-form-fileup-error";
                }
                fileflag = false;
            }else{
                //remove file error class
                if(filecls.className.split(" ").indexOf("dash-form-fileup-error") >= 0) {
                    filecls.classList.remove("dash-form-fileup-error");
                }
                fileflag = true;
            }

            if (!this.errors.any()) {
                if(!this.emailokflag){
                    this.$scrollTo('#vendoremaildiv');
                    return false;
                }
                if(!fileflag){
                    this.$scrollTo('#fileupload-div');
                    return false;
                }
                // console.log('No error');
                var terms = document.getElementById("agree").checked;
                console.log("Terms======"+terms);
                var inputElements = document.getElementsByName("link");
                var url = document.getElementById('url').value;
                var website = "";
                var wflag = true;
                for(var i=0; inputElements[i]; ++i){
                    if(inputElements[i].checked){
                        website = inputElements[i].value;
                    }
                }

                if(website == 'Yes'){
                    //validate website url
                    console.log('website yes');
                    var pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
                              if(!pattern.test(url)) {
                                document.getElementById('url').setAttribute("class", "dash-form-text-val dash-form-url left white width-100 has-error");
                                wflag = false;
                                this.$scrollTo('#urldiv');
                              } else {
                                document.getElementById('url').setAttribute("class", "dash-form-text-val dash-form-url left white width-100");
                              }
                }else{
                    document.getElementById('url').setAttribute("class", "dash-form-text-val dash-form-url left white width-100");
                }

                if(!terms){
                    document.getElementById('terms').setAttribute("class", "control__indicator red-border");
                    this.formSubmitted = false;
                }else{
                    document.getElementById('terms').setAttribute("class", "control__indicator");
                }

                console.log(terms + '  '+ wflag + ' ' + fileflag);

                if((terms) && (wflag) && (fileflag)){
                    this.formSubmitted = true;
                }else{
                    this.formSubmitted = false;
                    // need to set agree checkbox red
                    return false;
                }

            }else{
                var errors = this.errors.all();
                console.log(errors);
                if((errors[0].includes("appname")) || (errors[0].includes("appdesc"))){
                    this.$scrollTo('#basicinfobox');
                }else if((errors[0].includes("name")) || (errors[0].includes("email")) || (errors[0].includes("number")) || (errors[0].includes("password"))){
                    this.$scrollTo('#admininfobox');
                }
                this.formSubmitted = false;
                return false;
            }
          },
        usecaseChange(mode){
            this.seltype = mode;
            if(mode == 'MOOC'){
                if(this.planData.planname == 'STARTER'){
                    this.customopt = false;
                }else{
                    this.customopt = true;
                }
            }else{
                this.customopt = false;
            }

        },
        themeChange(mode){
            var element = "";
            // console.log(element.classList);
            if(mode == 'casual'){
                element = document.getElementById('modern-con').getElementsByTagName('label')[0];
                document.getElementById('modern').setAttribute("disabled", "true");
                element.classList.add('lbl-disabled');
                element.classList.remove('lbl');
            }else{
                element = document.getElementById('modern-con').getElementsByTagName('label')[0];
                document.getElementById('modern').removeAttribute("disabled");
                element.classList.add('lbl');
                element.classList.remove('lbl-disabled');
            }

            if(mode == 'modern'){
                element = document.getElementById('casual-con').getElementsByTagName('label')[0];
                document.getElementById('casual').setAttribute("disabled", "true");
                element.classList.add('lbl-disabled');
                element.classList.remove('lbl');
            }else{
                element = document.getElementById('casual-con').getElementsByTagName('label')[0];
                document.getElementById('casual').removeAttribute("disabled");
                element.classList.add('lbl');
                element.classList.remove('lbl-disabled');

            }


        },
        submitForm(data,mode,userdata){

            var retrievedObject = localStorage.getItem('themeObject');
            var resobj = JSON.parse(retrievedObject);
            var theme = new Date(resobj.number);
            var ver = 'A';
            if((theme%2) != 0){
                ver = 'B';
            }

            var amount = 0;
            if((this.renewperiod) == 'YEAR'){
                amount = this.planData.yearlydiscountedprice;
            }
            if((this.renewperiod) == 'MONTH'){
                amount = this.planData.monthlydiscountedprice;
            }
            var url = this.apibaseurl+'/vendor/v1/signup';
            var formData = data;
            //var hurl = window.location.protocol+"//"+url;
            var hurl = url;
            var email = data.get('vendoremail');
            this.$http.post(hurl,formData).then( function(response){
                  console.log("Success"+response.data);
                  var result = response.data;
                  if(result.success){
                        // GTM Code starts
                            // Subscription
                             window.dataLayer = window.dataLayer || [];
                             window.dataLayer.push({
                                 'event':'VLITE_SUBSCRIPTION',
                                 'EventCategory': 'VLITE_SUBSCRIPTION',
                                 'EventAction': 'Subscription',
                                 'EventLabel': 'SIGNUP_SUCCESS',
                                 'EventValue': 1,
                                 'Name': this.name,
                                 'Email': this.email,
                                 'Contact': this.number,
                                 'Mode': mode,
                                 'Plan': this.planData.planname,
                                 'PlanPeriod': this.renewperiod,
                                 'Status': 'Success',
                                 'Version': ver
                             });
                            // Payment
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                'event':'VLITE_SUBSCRIPTION',
                                'EventCategory': 'VLITE_SUBSCRIPTION',
                                'EventAction': 'Payment',
                                'EventLabel': 'PAYMENT_SUCCESS',
                                'EventValue': 1,
                                'Name': this.name,
                                'Email': this.email,
                                'Contact': this.number,
                                'Mode': mode,
                                'Plan': this.planData.planname,
                                'PlanPeriod': this.renewperiod,
                                'Amount': amount,
                                'Status': 'Success',
                                'Version': ver
                            });
                        // End of GTM Code
                    this.mainloaderStatus = false;
                    //Remove exsisting plans
                    localStorage.removeItem('planobj');
                    localStorage.removeItem('priorplanobj');
                      this.$router.push({ name: 'Success', params: { plandata: this.planData, vendorid: result.success, email: email }});

                  }else{
                      // GTM Code starts
                          // Subscription
                           window.dataLayer = window.dataLayer || [];
                           window.dataLayer.push({
                               'event':'VLITE_SUBSCRIPTION',
                               'EventCategory': 'VLITE_SUBSCRIPTION',
                               'EventAction': 'Subscription',
                               'EventLabel': 'SIGNUP_FAILED',
                               'EventValue': 1,
                               'Name': this.name,
                               'Email': this.email,
                               'Contact': this.number,
                               'Mode': mode,
                               'Plan': this.planData.planname,
                               'PlanPeriod': this.renewperiod,
                               'Status': 'Failed',
                               'Version': ver
                           });
                          // Payment
                          window.dataLayer = window.dataLayer || [];
                          window.dataLayer.push({
                              'event':'VLITE_SUBSCRIPTION',
                              'EventCategory': 'VLITE_SUBSCRIPTION',
                              'EventAction': 'Payment',
                              'EventLabel': 'PAYMENT_FAILED',
                              'EventValue': 1,
                              'Name': this.name,
                              'Email': this.email,
                              'Contact': this.number,
                              'Mode': mode,
                              'Plan': this.planData.planname,
                              'PlanPeriod': this.renewperiod,
                              'Amount': amount,
                              'Status': 'Failed',
                              'Version': ver
                          });
                      // End of GTM Code
                    this.mainloaderStatus = false;
                    this.$router.push({ name: 'Failed', params: { plandata: this.planData, reason: result.reason,email: email,userdata:userdata }});
                  }
              }, function (response) {
                  // GTM Code starts
                      // Subscription
                       window.dataLayer = window.dataLayer || [];
                       window.dataLayer.push({
                           'event':'VLITE_SUBSCRIPTION',
                           'EventCategory': 'VLITE_SUBSCRIPTION',
                           'EventAction': 'Subscription',
                           'EventLabel': 'SIGNUP_FAILED',
                           'EventValue': 1,
                           'Name': this.name,
                           'Email': this.email,
                           'Contact': this.number,
                           'Mode': mode,
                           'Plan': this.planData.planname,
                           'PlanPeriod': this.renewperiod,
                           'Status': 'Failed',
                           'Version': ver
                       });
                  // End of GTM Code
                    this.mainloaderStatus = false;
                  this.$router.push({ name: 'Failed', params: { plandata: this.planData, reason: 'Some Error Occured', email: email,userdata:userdata }});
             });
          },
        changeUrlValidation(value){
            if(value){
                document.getElementById('url').setAttribute("data-vv-rules", "required");
            }else{
                document.getElementById('url').setAttribute("data-vv-rules", "none");
            }
        },
        fileUpload(){
            var elmnt = document.getElementById("fileupload-div");
            elmnt.scrollIntoView();
            var url = this.apibaseurl+'/vendor/v1/fileupload';
            var fileval=document.getElementById("fileup");

            var filePath = fileval.value;
            var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
            if(!allowedExtensions.exec(filePath)){
                document.getElementById('dash-fileup-label-msg').setAttribute("class", "dash-form-fup-label inline-blk p-top-10 has-error-label-text");
                self.fileuploadLabel = "File Format Not Supported(png/jpg/jpeg).";
                return false;
            }

            var files = fileval.files;
            // console.log(files[0]);
            var reader = new FileReader();
            var self = this;
            var filecls = document.getElementById("logofilebtn");

            if(files[0].size > 3145728){
                document.getElementById('dash-fileup-label-msg').setAttribute("class", "dash-form-fup-label inline-blk p-top-10 has-error-label-text");
                self.fileuploadLabel = "File Max Size 3MB Supported.";
                return false;
            }
            //Read the contents of Image File.
            reader.readAsDataURL(files[0]);
            reader.onload = function (e) {
                //Initiate the JavaScript Image object.
                var image = new Image();

                //Set the Base64 string return from FileReader as source.
                image.src = e.target.result;

                //Validate the File Height and Width.
                image.onload = function () {
                    var height = this.height;
                    var width = this.width;
                    if((height < 1024) || (width < 1024)){
                        document.getElementById('dash-fileup-label-msg').setAttribute("class", "dash-form-fup-label inline-blk p-top-10 has-error-label-text");
                        self.fileuploadLabel = "Min Image resolution Should 1024*1024";
                    }else{
                        // console.log('success');
                        self.loaderStatus = true;
                        document.getElementById('dash-fileup-label-msg').setAttribute("class", "dash-form-fup-label inline-blk p-top-10");
                        // var hurl = window.location.protocol+"//"+url;
                        var hurl = url;
                        var formData = new FormData();
                        formData.append('filename', files[0]);
                        formData.append('mode', 'guest');
                        const config = { headers: { 'Content-Type': 'multipart/form-data' } };
                        self.fileuploadLabel = "Uploading..."+files[0].name;
                        self.$http.post(hurl,formData,config).then( function(response){
                              self.loaderStatus = false;
                              self.fileBtnLabel = "CHANGE";
                              //changing error class
                              if(filecls.className.split(" ").indexOf("dash-form-fileup-error") >= 0) {
                                  filecls.classList.remove("dash-form-fileup-error");
                              }
                              console.log("Success"+response.data);
                              var result = response.data;
                              if(result.success){
                                  self.fileuploadLabel = files[0].name+" Success.";
                                  self.filename = files[0].name;
                                  self.logo = result.success;
                              }else{
                                  document.getElementById('dash-fileup-label-msg').setAttribute("class", "dash-form-fup-label inline-blk p-top-10 has-error-label-text");
                                  self.fileuploadLabel = " Failed "+result.reason;
                              }
                          }, function (response) {
                              self.loaderStatus = false;
                              document.getElementById('dash-fileup-label-msg').setAttribute("class", "dash-form-fup-label inline-blk p-top-10 has-error-label-text");
                              self.fileuploadLabel = "Oops! Try Again";
                            //   console.log("Failed");
                         });
                    }
                };
            }

         },
         openNewTab() {
             window.open(this.vendorportalurl, '_blank');
         },
         openSocialNewTab(surl){
             window.open(surl, '_blank');
         },
         switchTopriorPlan(){
             if((this.priorplan == '') || (this.planData.planid == this.priorplan.planid)){
                 this.planData = this.planData;
             }else{
                 this.skipplanname = this.planData.planname;
                 this.backupPlan = this.planData;
                 this.planData = this.priorplan;
                 this.lowerplanstatus = true;
             }
             this.customoptionshow();

         },
         switchBackTopriorPlan(){
             if(this.backupPlan != ''){
                 this.skipplanname = "";
                 this.planData = this.backupPlan;
                 this.lowerplanstatus = false;
             }
             this.customoptionshow();
            //  console.log(this.planData);
         },
         emailPrecheck(){
             var des = document.getElementById('vendoremail');
             var deslabel = document.getElementById('vendoremail-label');
             var successClasslabel = deslabel.classList.contains('has-success-label-text');
             if(successClasslabel){
                 deslabel.classList.remove("has-success-label-text");
             }
             var dangerClasslabel = deslabel.classList.contains('has-error-label-text');
             if(dangerClasslabel){
                 deslabel.classList.remove("has-error-label-text");
             }
             var emailval = des.value;
             if (emailval.replace(/\s/g, "").length == 0) {
                 this.emailokflag=false;
                //  var hasDangerClass = des.classList.contains('has-error');
                //  if(hasDangerClass){
                //      des.classList.remove("has-error");
                //  }
                 document.getElementById('vendoremail-label').innerHTML = 'Your email id';
             }else{
                 var email = document.getElementById('vendoremail').value;
                 var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                 if(re.test(email)){
                     //API Call to check email avaliablility
                    //  var url = this.apibaseurl+'/vendor/v1/signup/emailverify';
                     var hurl = this.apibaseurl+'/vendor/v1/signup/emailprecheck?email='+email;
                     var payload = {};
                     var protocol = window.location.protocol;
                     this.emailspin = true;
                     this.$http({url: hurl, payload: payload, method: 'GET'}).then(function (response) {
                         console.log('Success!:', response.data);
                         this.emailspin = false;

                         var data = response.data;
                         if((data.error)){
                             if((data.error==2128) || (data.error==2129) || (data.error==2130) || (data.error==2131)){

                                 var hasSuccessClasslabel = deslabel.classList.contains('has-success-label-text');
                                 if(!hasSuccessClasslabel){
                                     deslabel.classList.remove("has-success-label-text");
                                 }

                                 var hasDangerClass = des.classList.contains('has-error');
                                 if(!hasDangerClass){
                                     des.className += " has-error";
                                 }
                                 var hasDangerClasslabel = deslabel.classList.contains('has-error-label-text');
                                 if(!hasDangerClasslabel){
                                     deslabel.className += " has-error-label-text";
                                 }

                                document.getElementById('vendoremail-label').innerHTML = 'Email Id  Not Avaliable';
                             }
                             this.emailokflag=false;
                         }else{
                             var hasDangerClass = des.classList.contains('has-error');
                             if(hasDangerClass){
                                 des.classList.remove("has-error");
                             }
                             var hasDangerClasslabel = deslabel.classList.contains('has-error-label-text');
                             if(!hasDangerClasslabel){
                                 deslabel.classList.remove("has-error-label-text");
                             }
                             var hasSuccessClasslabel = deslabel.classList.contains('has-success-label-text');
                             if(!hasSuccessClasslabel){
                                 deslabel.className += " has-success-label-text";
                             }
                             document.getElementById('vendoremail-label').innerHTML = 'Email Id Avaliable';
                             this.emailokflag=true;
                         }
                     }, function (response) {
                         console.log('Error!:', response.data);
                         this.emailokflag=false;
                         this.emailspin = false;
                         var hasDangerClass = des.classList.contains('has-error');
                         if(!hasDangerClass){
                             des.className += " has-error";
                         }
                         var hasSuccessClasslabel = deslabel.classList.contains('has-success-label-text');
                         if(!hasSuccessClasslabel){
                             deslabel.classList.remove("has-success-label-text");
                         }
                         var hasDangerClasslabel = deslabel.classList.contains('has-error-label-text');
                         if(!hasDangerClasslabel){
                             deslabel.className += " has-error-label-text";
                         }
                         document.getElementById('vendoremail-label').innerHTML = 'Oops! Try again...';
                     });
                 }else{
                     this.emailokflag=false;
                 }

             }
         },
         restoreData(){
             if(Object.keys(this.userdata).length > 0){
                //   console.log(this.userdata);
                 this.appname = this.userdata.appname;
                 this.appdesc = this.userdata.appdesc;
                 document.getElementById('fb').value = this.userdata.fb;
                 document.getElementById('gp').value = this.userdata.gp;
                 document.getElementById('tw').value = this.userdata.tw;
                 this.name = this.userdata.vendorname;
                 this.email = this.userdata.vendoremail;
                 this.number = this.userdata.phone;
                 this.password = this.userdata.password;
                 this.cpassword = this.userdata.password;
                 this.website = this.userdata.url;
                 this.filename = this.userdata.filename;
                 this.fileuploadLabel = this.userdata.filetext;
                 this.logo = this.userdata.logo;
                 this.fileBtnLabel = "CHANGE";
                     var inputElements = document.getElementsByName("type");
                     for(var i=0; inputElements[i]; ++i){
                             if(inputElements[i].value == (this.userdata.vendormode)){
                                 inputElements[i].checked = true;
                                 break;
                             }
                         }
                     inputElements = document.getElementsByName("mode");
                     var str = this.userdata.mode;
                     var restr = str.toLowerCase(restr);
                      this.themeChange(restr);
                     for(var i=0; inputElements[i]; ++i){
                         if(inputElements[i].value == (this.userdata.mode)){
                             inputElements[i].checked = true;
                             if((inputElements[i].value == 'Modern') && (this.userdata.modetheme == 'Dark')){
                                 document.getElementById("modern").checked = true;
                                 this.changemodrentheme();
                             }
                             if((inputElements[i].value == 'Casual') && (this.userdata.modetheme == 'Dark')){
                                 document.getElementById("modern").checked = true;
                                 this.changecasualtheme();
                             }
                                 break;
                         }
                     }


                     inputElements = document.getElementsByName("renewperiod");
                     for(var i=0; inputElements[i]; ++i){
                         if(inputElements[i].value == (this.userdata.renewperiod)){
                             inputElements[i].checked = true;
                                 break;
                         }
                     }

                    this.$scrollTo('#billingdiv');
                 }
         }

        }
    }



</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue